// extracted by mini-css-extract-plugin
export default {"SanitizedHtml":"use-labels-editor-module__SanitizedHtml--BEOfv","Box":"use-labels-editor-module__Box--nXLKj"};